import './App.css';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import Error from './views/pages/Error/Error';
import PDFResources from './views/Layouts/Pdf-resources';
import ScrollToTop from './views/Scrolltotop';

import CarepartnerResources from './views/pages/CarepartnerResources/Carepartner-Resources';
import CommonQuestion from './views/pages/CommonQuestion/Common-question';
import AboutInbrija from './views/pages/AboutInbrija/About-Inbrija';
import ContactUs from './views/pages/ContactUs/Contact-us';
import Homepage from './views/pages/Homepage/Homepage';
import HowToUseInbrija from './views/pages/HowToUse/How-to-use-inbrija';
import ImbrijaStories from './views/pages/InbrijaStories/Inbrija-stories';
import MuhammadAli from './views/pages/MuhammadAli/muhammad-ali';
import OffPeriods from './views/pages/OffPeriods/OffPeriods';
import PeopleOnInbrija from './views/pages/PeopleOnIbrija/PeopleOnIbrija';
import SignUp from './views/pages/Signup/Sign-up';
import SiteMap from './views/pages/SiteMap/Site-map';
import SavingSupport from './views/pages/SavingSupport/Saving-and-support';
import ToolsResources from './views/pages/ToolsResources/Tools-and-Resources';
import Thankyou from './views/pages/Thankyou/Thankyou';
import ThankyouEng from './views/pages/Thankyou/Thankyou-eng';
import UnSubscribePage from './views/pages/Unsubscribe/Unsubscribe';
import UnSubscribed from './views/pages/Unsubscribe/Unsubscribed';

import "bootstrap/dist/css/bootstrap.min.css";

function App({ props }) {

  const routes = [
    { path: '/', component: Homepage },
    { path: "/about-inbrija", component: AboutInbrija },
    { path: "/carepartner-resources", component: CarepartnerResources },
    { path: "/common-questions", component: CommonQuestion },
    { path: "/contact-us", component: ContactUs },
    { path: "/for-people-on-inbrija", component: PeopleOnInbrija },
    { path: "/how-to-use-inbrija", component: HowToUseInbrija },
    { path: "/inbrija-stories", component: ImbrijaStories },
    { path: "/language-thank-you", component: ThankyouEng },
    { path: "/muhammad-ali", component: MuhammadAli },
    { path: "/pdf-resources", component: PDFResources },
    { path: "/savings-and-support", component: SavingSupport },
    { path: "/tools-and-resources", component: ToolsResources },
    { path: "/sign-up", component: SignUp },
    { path: "/sitemap", component: SiteMap },
    { path: "/thank-you", component: Thankyou },
    { path: "/unsubscribe", component: UnSubscribePage },
    { path: "/unsubscribe-confirmation", component: UnSubscribed },
    { path: "/what-are-off-periods", component: OffPeriods },
  ];

  return (
    <div className="App" id='routes-id'>
      <HelmetProvider>
        <BrowserRouter future={{ v7_relativeSplatPath: true }}>
          <ScrollToTop />
          <Routes>
            <Route path="*" element={<Error />} />
            {routes.map((route, index) => (
              <Route key={index} path={route.path}>
                <Route path={route.path} element={<route.component />} />
              </Route>
            ))}

            <Route exact path="/about" element={<Navigate replace to="/about-inbrija" />} />
            <Route exact path="/ask-for-inbrija" element={<Navigate replace to="/about-inbrija" />} />
            <Route exact path="/financial-services" element={<Navigate replace to="/savings-and-support#savings-programs" />} />
            <Route exact path="/how-to-use" element={<Navigate replace to="/how-to-use-inbrija" />} />
            <Route exact path="/off-periods" element={<Navigate replace to="/what-are-off-periods" />} />
            <Route exact path="/patient-support" element={<Navigate replace to="/savings-and-support#prescription-services" />} />
            <Route exact path="/patient-video" element={<Navigate replace to="/" />} />
            <Route exact path="/people-on-inbrija" element={<Navigate replace to="/" />} />
            <Route exact path="/prescription-support-services" element={<Navigate replace to="/savings-and-support#prescription-services" />} />
            <Route exact path="/savings-programs" element={<Navigate replace to="/savings-and-support#savings-programs" />} />
            <Route exact path="/sign-up" element={<Navigate replace to="/" />} />
            <Route exact path="/talking-to-doctor" element={<Navigate replace to="/about-inbrija#talking-with-doctor" />} />
            <Route exact path="/telemedicine" element={<Navigate replace to="/" />} />
          </Routes>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;


